import { useTranslation } from "react-i18next";
import { UserRoles } from "../../../../Constants/userRoles";
import { VossScheduledChangeStatus } from "../../../../Constants/VOSS/vossScheduledChangeStatus";
import useUserAccess from "../../../../Hooks/useUserAccess";
import { Dropdown } from "../../../FormComponents/Dropdown";
import DatePicker from '../../../Fundamentals/DatePicker';
import { ReadOnlyField } from "../../../FormComponents/Input/Input";
import SkynetForm from "../../../Fundamentals/Form/SkynetForm";
import { IntermediarySelector } from "../../../Voss/IntermediarySelector";
import subscriptionUtils from "../../../../Utils/subscriptionUtils";

const EditSubscriptionForm = ({ offer, form, subscription, onChange, intermediaries, blockEdit }) => {
    const { t } = useTranslation();
    const { hasAdminAccess } = useUserAccess();

    const scheduledChange = subscription?.scheduledChanges.filter(x => x.status === VossScheduledChangeStatus.Pending || x.status === VossScheduledChangeStatus.CompletedForUpcomingPeriod).pop();
    const pendingTierChange = scheduledChange?.tier;
    const pendingPlanChange = scheduledChange?.plan;
    const chargePlans = offer?.chargePlans.filter(x => x.tierId === pendingTierChange?.id || x.tierId === form.data.tierId).map(cp => cp.planId);
    const selectablePlans = offer?.plans.filter(x => chargePlans.includes(x.id));

    if (!subscription)
        return;

    const hasEvergreenBindingPeriod = subscriptionUtils.hasEvergreenBindingPeriod(subscription);
    const hasEvergreenEndDate = hasEvergreenBindingPeriod || subscriptionUtils.hasEvergreenBillingPeriod(subscription);

    return (
        <SkynetForm>
            <div className="row gap-24">
                <div className="col m-0 p-0">
                    <fieldset className="d-grid gap-12">
                        <legend className="mb-12">{t('editsubscriptionform.tier')}</legend>
                        <ReadOnlyField value={subscription.tier.name} />
                    </fieldset>
                    {hasAdminAccess(UserRoles.SubscriptionAdmin) && !hasEvergreenEndDate && (
                        <fieldset className="d-grid gap-12" disabled={blockEdit}>
                            <legend className="mb-12">{t('editsubscriptionform.changeenddate')}</legend>
                            <DatePicker dateFormat={"YYYY-MM-DD"} showTime={false} field="endDate" isValidDate={(current) => current.date() === 1} onChange={(value) => onChange(form.id, value, 'endDate')} value={form.data.endDate} />
                        </fieldset>
                    )}
                    <fieldset className="d-grid gap-12" disabled={pendingPlanChange || hasEvergreenBindingPeriod}>
                        <legend className="mb-12">{t('subscriptions.period')}</legend>
                        <Dropdown options={selectablePlans} value={pendingPlanChange?.id ?? form.data.planId} onChange={(value) => onChange(form.id, value, 'planId')} />
                        {hasEvergreenBindingPeriod && <span className="help-block">{t('editsubscriptionform.evergreenPlanChangeNotPossible')}</span>}
                    </fieldset>
                    {intermediaries && (
                        <fieldset className="d-grid gap-12">
                            <legend className="mb-12">{t('editsubscriptionform.intermediary')}</legend>
                            <IntermediarySelector intermediaries={intermediaries} onChange={(value) => onChange(form.id, value, 'intermediaryInvoicingId')} value={form.data.intermediaryInvoicingId} />
                        </fieldset>
                    )}
                </div>
            </div>
        </SkynetForm>
    );
};

export default EditSubscriptionForm;
